import React, { useState } from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/cn";

const avatarStyles = cva(
  "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-neutral-100 dark:bg-neutral-800 font-medium text-neutral-700 dark:text-neutral-200",
  {
    variants: {
      size: {
        sm: "h-8 w-8 text-xs",
        md: "h-10 w-10 text-sm",
        lg: "h-14 w-14 text-lg",
      },
    },
    defaultVariants: {
      size: "md",
    },
  }
);

function getInitials(name) {
  if (!name) return "";
  const parts = name.trim().split(/\s+/);
  const initials = parts.slice(0, 2).map((part) => part[0]?.toUpperCase());
  return initials.join("");
}

/**
 * Avatar - image or initials fallback.
 * @param {string} [src]
 * @param {string} [name] - used for initials fallback and alt text
 * @param {"sm"|"md"|"lg"} [size="md"]
 * @param {string} [className]
 */
export function Avatar({ src, name, size = "md", className, ...props }) {
  const [imgError, setImgError] = useState(false);
  const showImage = src && !imgError;

  return (
    <span className={cn(avatarStyles({ size }), className)} {...props}>
      {showImage ? (
        <img
          src={src}
          alt={name || "Avatar"}
          className="h-full w-full object-cover"
          onError={() => setImgError(true)}
        />
      ) : (
        <span aria-hidden="true">{getInitials(name)}</span>
      )}
    </span>
  );
}
